module.exports = __webpack_public_path__ + "img/portrait-021.24cb1ad8.jpg";